import { jsx as _jsx } from "react/jsx-runtime";
import parse, { attributesToProps, domToReact, } from "html-react-parser";
import { Link, Typography } from "@mui/material";
import DOMPurify from "dompurify";
import { logger } from "@moodys/mdc-frontend.services.logger";
DOMPurify.addHook("afterSanitizeAttributes", function (node) {
    if ("target" in node) {
        node.setAttribute("target", "_blank");
        node.setAttribute("rel", "noopener noreferrer");
    }
});
DOMPurify.addHook("afterSanitizeElements", function (node) {
    const TAGS_THAT_CANNOT_BE_EMPTY = ["p", "b", "u", "a"];
    if (TAGS_THAT_CANNOT_BE_EMPTY.includes(node.nodeName.toLowerCase()) &&
        node.innerHTML.trim().length === 0) {
        node.parentNode?.removeChild(node);
    }
});
const transformElement = (node) => {
    const { attribs, name, children } = node;
    const props = attributesToProps(attribs);
    switch (name?.toLowerCase()) {
        case "p":
            return (_jsx(Typography, { variant: "body1", ...props, children: domToReact(children, PARSER_REPLACE_OPTIONS) }));
        case "a":
            return (_jsx(Link, { ...props, children: domToReact(children, PARSER_REPLACE_OPTIONS) }));
    }
};
export const replaceDOMNode = (node) => {
    if (node.type === "tag" && "attribs" in node) {
        return transformElement(node);
    }
    return undefined;
};
const PARSER_REPLACE_OPTIONS = {
    replace: replaceDOMNode,
};
export const sanitizeAndTransformHtml = ({ htmlString, shouldDecode = false, parserOptions = PARSER_REPLACE_OPTIONS, }) => {
    if (!htmlString) {
        return null;
    }
    try {
        let stringToSanitize = htmlString;
        if (shouldDecode) {
            stringToSanitize = decodeURIComponent(htmlString);
        }
        const cleanHtmlString = DOMPurify.sanitize(stringToSanitize);
        return parse(cleanHtmlString, parserOptions);
    }
    catch (error) {
        logger.error({ error });
        return null;
    }
};
//# sourceMappingURL=html-sanitizer.js.map